import React, { useState } from "react";
import styles from "./Gallery.module.scss";
import { Link } from "react-router-dom";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import img3 from "../../assests/inst (1).webp";
import img4 from "../../assests/inst (2).webp";
import img5 from "../../assests/inst (3).webp";
import img6 from "../../assests/img (1).webp";
import img7 from "../../assests/img (5).webp";
import img8 from "../../assests/img (3).webp";
import img11 from "../../assests/img(11).webp";
import img12 from "../../assests/img (4).webp";
import Award1 from "../../assests/award/award1.webp"
import Award2 from "../../assests/award/award2.webp"
import Award4 from "../../assests/award/award4.webp"
import Award5 from "../../assests/award/award5.webp"
import Award6 from "../../assests/award/award6.webp"
import Award7 from "../../assests/award/award7.webp"
import Award8 from "../../assests/award/award8.webp"
import Award9 from "../../assests/award/award9.webp"
import Award10 from "../../assests/award/award10.webp"
import Award11 from "../../assests/award/award11.webp"
import Award12 from "../../assests/award/award12.webp"
import Award13 from "../../assests/award/award13.webp"
import Award14 from "../../assests/award/award14.webp"
import Award15 from "../../assests/award/award15.webp"
import Award16 from "../../assests/award/award16.webp"
import Class1 from "../../assests/class/class1.webp"
import Class2 from "../../assests/class/class2.webp"
import Class3 from "../../assests/class/class3.webp"
import Class4 from "../../assests/class/class4.webp"
import Class5 from "../../assests/class/class5.webp"
import Class6 from "../../assests/class/class6.webp"
import Class7 from "../../assests/class/class7.webp"
import Class8 from "../../assests/class/class8.webp"
import Class9 from "../../assests/class/class9.webp"
import Class10 from "../../assests/class/class10.webp"
import Class11 from "../../assests/class/class11.webp"
import Class12 from "../../assests/class/class12.webp"
import Class13 from "../../assests/class/class13.webp"
import Class14 from "../../assests/class/class14.webp"
import Class15 from "../../assests/class/class15.webp"
import Class16 from "../../assests/class/class16.webp"
import Class17 from "../../assests/class/class17.webp"
import Class18 from "../../assests/class/class18.webp"
import Class19 from "../../assests/class/class19.webp"


export default function Gallery() {
  const [category, setCategory] = useState("all");
  const [fade, setFade] = useState(false);

  const Classes = [

    { img: img6, title: "", },
    { img: img7, title: "", },
    { img: img8, title: "", },
    { img: img12, title: "", },
    { img: Class1, title: "", },
    { img: Class2, title: "", },
    { img: Class3, title: "", },
    { img: Class4, title: "", },
    { img: Class5, title: "", },
    { img: Class6, title: "", },
    { img: Class7, title: "", },
    { img: Class8, title: "", },
    { img: Class9, title: "", },
    { img: Class10, title: "", },
    { img: Class11, title: "", },
    { img: Class12, title: "", },
    { img: Class13, title: "", },
    { img: Class14, title: "", },
    { img: Class15, title: "", },
    { img: Class16, title: "", },
    { img: Class17, title: "", },
    { img: Class18, title: "", },
    { img: Class19, title: "", },

  ];

  const Instruments = [
    { img: img3, title: "", },
    { img: img4, title: "", },
    { img: img5, title: "", },
    { img: img11, title: "", },
  ];

  const Awards = [
    { img: Award1, title: "", },
    { img: Award2, title: "", },
    { img: Award4, title: "", },
    { img: Award5, title: "", },
    { img: Award6, title: "", },
    { img: Award7, title: "", },
    { img: Award8, title: "", },
    { img: Award9, title: "", },
    { img: Award10, title: "", },
    { img: Award11, title: "", },
    { img: Award12, title: "", },
    { img: Award13, title: "", },
    { img: Award14, title: "", },
    { img: Award15, title: "", },
    { img: Award16, title: "", },

  ]

  const allItems = [...Classes, ...Instruments];

  const filteredItems =
    category === "all"
      ? allItems
      : category === "Instruments"
        ? Instruments
        : category === "Classes"
          ? Classes
          : category === "Awards"
            ? Awards
            : [];

  const handleCategoryChange = (selectedCategory) => {
    setFade(true);
    setTimeout(() => {
      setCategory(selectedCategory);
      setFade(false);
    }, 300);
  };

  return (
    <div>
      <div className={styles.heading}>
        <div className="container">
          <h1>Gallery</h1>
        </div>

      </div>
      <section className={styles.gallery}>
        <div className="container">
          <div className={styles.glry_nav}>
            <ul>
              <li>
                <Link
                  onClick={() => handleCategoryChange("all")}
                  className={category === "all" ? styles.active : ""}
                >
                  All categories
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => handleCategoryChange("Instruments")}
                  className={category === "Instruments" ? styles.active : ""}
                >
                  Instruments
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => handleCategoryChange("Classes")}
                  className={category === "Classes" ? styles.active : ""}
                >
                  Classes
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => handleCategoryChange("Awards")}
                  className={category === "Awards" ? styles.active : ""}
                >
                  Awards
                </Link>
              </li>
            </ul>
          </div>

          <div className={styles.img_body}>
            <ImageList
              cols={4}
              className={fade ? styles.fadeOut : styles.fadeIn}
            >
              {filteredItems.map((item, index) => (
                <ImageListItem key={index}>
                  <div className={styles.img}>
                    <img
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </div>
                </ImageListItem>
              ))}
            </ImageList>
          </div>
        </div>
      </section>
    </div>
  );
}
